export const ONBOARDING_STEP_TRANSITION_ANIMATION = {
  variants: {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
  },
  transition: { duration: 0.5 },
  initial: 'hidden',
  animate: 'visible',
  exit: 'exit',
}
